
    // this file was auto generated by python script
    import CameraOff from './CameraOff';
    export default CameraOff;
    